import React, { useState, useRef, useEffect, useContext } from 'react';
import { IonContent, IonHeader, IonTitle, IonToolbar, IonItem, IonList, IonSplitPane, IonMenuButton, IonButton, IonButtons, IonInput, IonModal, IonGrid, IonRow, IonCol, IonSlides, IonLoading } from '@ionic/react';
import { IonTabs, IonTabBar, IonTabButton, IonText, IonLabel, IonFooter, IonSlide, IonImg, IonRouterOutlet } from '@ionic/react';
import { Redirect} from 'react-router-dom';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';
import { EnterPasswordModal } from '../../../zInternal_Features/merchant/components/Modal_EnterPassword';
import { ShowRoomPicsModal } from './Modal_ShowRoomPics';
import { CreateInventoryRoomModal } from './Modal_CreateInventoryRoom';

import '../../../css/layout.css';

import { CreateInventoryItemModal } from './Modal_CreateInventoryItem';
import { Modal_CreateIngredient } from './Modal_Create_Ingredient';

export function InventoryRoomDetailsModal (props) {

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [employeeID, setEmployeeID] = useState(authenticatedMerchent_context.employeeID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);


    let [createInventoryRoomModal, setCreateInventoryRoomModal] = useState(false);
    let [stockInventoryRoomModal, setStockInventoryRoomModal] = useState(false);
    let [deleteInventoryRoomModal, setDeleteInventoryRoomModal] = useState(false);
    let [adminPasswordCreateInventoryRoomModal, setAdminPasswordCreateInventoryRoomModal] = useState(false);

    let [createInventoryItemModal, setCreateInventoryItemModal] = useState(false);
    let [stockInventoryItemModal, setStockInventoryItemModal] = useState(false);
    let [deleteInventoryItemModal, setDeleteInventoryItemModal] = useState(false);
    let [adminPasswordCreateInventoryItemModal, setAdminPasswordCreateInventoryItemModal] = useState(false);
    let [adminPasswordDeleteItemModal, setAdminPasswordDeleteItemModal] = useState(false);

    let [selectedFile, seteSlectedFile] = useState(null);

    let [viewRoomDetailsData, setViewRoomDetailsData] = useState([]);
    let [viewRoomItemsDetailsData, setViewRoomItemsDetailsData] = useState([]);

    let [viewItemDetailsData, setViewItemDetailsData] = useState([]);

    let [quantityAddedToRoom, setQuantityAddedToRoom] = useState(null);
    let [quantityReplenishedStock, setQuantityReplenishedStock] = useState(null);

    let [inventoryAccessCheckboxValue, setInventoryAccessCheckboxValue] = useState(null);

    let [roomID, setRoomID] = useState(null);
    let [roomType, setRoomType] = useState(null);
    let [roomDescription, setRoomDescription] = useState(null);
    let [roomPartNum, setRoomPartNum] = useState(null);
    let [roomPhoneNumber, setRoomPhoneNumber] = useState(null);
    let [roomAddress, setRoomAddress] = useState(null);
    let [roomCity, setRoomCity] = useState(null);
    let [roomCountry, setRoomCountry] = useState(null);
    let [roomCostPerUnit, setRoomCostPerUnit] = useState(null);
    let [roomSalePrice, setRoomSalePrice] = useState(null);
    let [roomPic1, setRoomPic1] = useState("/var/www/web/Public/fileServer/merchants/image-not-available.jpg");
    let [roomPic2, setRoomPic2] = useState("/var/www/web/Public/fileServer/merchants/image-not-available.jpg");
    let [roomPic3, setRoomPic3] = useState("/var/www/web/Public/fileServer/merchants/image-not-available.jpg");
    let [roomPic4, setRoomPic4] = useState("/var/www/web/Public/fileServer/merchants/image-not-available.jpg");
    let [roomPicsModal, setRoomPicsModal] = useState(false);
    let [roomDateCreated, setRoomDateCreated] = useState(null);
    let [roomAddedBy, setRoomAddedBy] = useState(null);
    let [roomIsActivated, setRoomIsActivated] = useState(null);

    let [inventory_roomsTab_data, setInventory_roomsTab_data] = useState('true');
    let [inventory_itemsTab_data, setInventory_itemsTab_data] = useState('false');

    let [inventory_roomsTab_view, setInventory_roomsTab_view] = useState('outline')
    let [inventory_itemsTab_view, setInventory_itemsTab_view] = useState('clear')

    let [itemID, setItemID] = useState(null);
    let [itemName, setItemName] = useState(null);
    let [attachment, setAttachment] = useState(null);
    let [createdByEmployee, setCreatedByEmployee] = useState(null);

    let [viewInventoryRoomMainDetailsData, setViewInventoryRoomMainDetailsData] = useState([]);
    let [viewInventoryItemMainDetailsData, setViewInventoryItemMainDetailsData] = useState([]);

    let [searchInventoryItem, setSearchInventoryItem] = useState(null);
    let [enterAdminPassword, setEnterAdminPassword] = useState(null);
    let [showRoomPics, setShowRoomPics] = useState(false);
    let [showRoomDetails, setShowRoomDetails] = useState(false);
    let [activateRoomButton, setActivateRoomButton] = useState('inline-block');
    let [deactivateRoomButton, setDeactivateRoomButton] = useState('inline-block');

    let [passwordCategory, setPasswordCategory] = useState(null);
    let [showPasswordModal, setShowPasswordModal] = useState(false);

    let [searchResults, setSearchResults] = useState([]);
    let [roomPublicPrice, setRoomPublicPrice] = useState(null);

    let [isloading, setLoading] = useState(false);

    let roomItemNameRef = useRef('');
    let itemNameRef = useRef('');

    let slideRef = useRef(null);


    function handleEnterAdminPassword(e) {   setEnterAdminPassword(e.target.value);    }


    function updateDeleteInventoryRoomModal(event) {

        if(event)
        {
            setDeleteInventoryRoomModal(event);
        }
        else
        {

            setDeleteInventoryRoomModal(event);
            setViewRoomDetailsData([]);
            setViewRoomItemsDetailsData([]);

        }
    }


    function updateDeleteInventoryItemModal(event) {

        if(event)
        {
            setDeleteInventoryItemModal(event);
        }
        else
        {
            setDeleteInventoryItemModal(event);
            setViewItemDetailsData([]);
        }

    }

   /*handleSearchInventoryItem(e) {
        setState(() => ({
            searchInventoryItem: e.target.value
        }));

        searchInventoryItemList();
    }*/
    function handleQuantityAddedToRoom(e) {

        setQuantityAddedToRoom(e.target.value);

    }

    function handleQuantityReplenish(e) {

        setQuantityReplenishedStock(e.target.value);

    }

    function handleInventoryAccessCheckbox(checkbox) {


        if(checkbox.checked === true){
            document.getElementById("submit").removeAttribute("disabled");

            setInventoryAccessCheckboxValue("y");

        }
        else{
            document.getElementById("submit").setAttribute("disabled", "disabled");
            setInventoryAccessCheckboxValue("n");
       }
    }


    function updateEnterAdminPasswordDeleteRoomModal(event) {

        setAdminPasswordCreateInventoryRoomModal(event);
        setDeleteInventoryRoomModal(false);
    }



    function updateEnterAdminPasswordDeleteItemModal(event) {

        setAdminPasswordCreateInventoryItemModal(event);
        setDeleteInventoryItemModal(false);
    }

    function saveUploadedFile(event) {
    
        //alert(event);
        
        if(event.target.files === null)
        {
            seteSlectedFile("/var/www/web/Public/fileServer/merchants/image-not-available.jpg")
        }
        else
        {
            seteSlectedFile(event.target.files[0]);

        }


    }



    function deleteRoom()
    {

        /*
        let formData = new FormData();
        formData.append('Tracker', 74399);
        formData.append('user', acctID);
        formData.append('xInventoryRoomID', roomID);
        formData.append('xEnterAdminPassword', enterAdminPassword);

        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        */

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            //body: JSON.stringify({formData})
            body: JSON.stringify({
                Tracker: 74399,
                user: acctID,
                xInventoryRoomID: roomID,
                xEnterAdminPassword: enterAdminPassword,
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);
        })
        .catch(error => {
            console.error(error);
        })

        setDeleteInventoryRoomModal(false);
        setAdminPasswordCreateInventoryRoomModal(false);

    }

    function deleteItem()
    {

        /*
        let formData = new FormData();
        formData.append('Tracker', 74499);
        formData.append('user', acctID);
        formData.append('xInventoryItemID', itemID);
        formData.append('xEnterAdminPassword', enterAdminPassword);

        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        */

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            //body: JSON.stringify({formData})
            body: JSON.stringify({
                Tracker: 74499,
                user: acctID,
                xInventoryItemID: itemID,
                xEnterAdminPassword: enterAdminPassword,
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);
        })
        .catch(error => {
            console.error(error);
        })

        setDeleteInventoryItemModal(false);
        setAdminPasswordCreateInventoryItemModal(false);

    }


    function searchList(event)
    {
        let searchCategory = event[0];
        let searchData = event[1];

        first_searchSuppliersInDB(searchCategory, searchData);

    }

    function first_searchSuppliersInDB(searchCategory, searchData, optionsData)
    {

        let formData = new FormData();
        let Tracker = '';

        //alert('Inside search room category');
        //alert(searchCategory);
        //alert(searchData);

        /*if(searchCategory === 'name')
        {

            Tracker = '74002S_N';
        }
        else if(searchCategory === 'phone')
        {
            Tracker = '74002S_P';

        }*/

        if(searchCategory === 'stock_room_item')
        {

            Tracker = '74302';
        }
        else if(searchCategory === 'delete_stock_room_item')
        {

            Tracker = '74304';

        }
        else if(searchCategory === 'stock_item' || searchCategory === 'delete_stock_item')
        {
            Tracker = '74402';
        }


        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: Tracker,
                user: acctID,
                xInventorySearchItem: searchData,
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

                        let rows = res.toString().split('~~~');

                        let rowLength = rows.length;

                            for (let rownum = 0; rownum < rowLength - 1; ++rownum)
                            {
                                let cols = rows[rownum].split('|');

                                setSearchResults((prevSearchResults) => {
                                    return prevSearchResults.concat({
                                        db_itemId: cols[0],
                                        db_itemName: cols[1],
                                        db_itemDescription: cols[2],
                                        db_vendorPartNumber: cols[3],
                                        db_vendorName: cols[4],
                                        db_vendorPhoneNumber: cols[5],
                                        db_vendorAddress: cols[6],
                                        db_vendorCity: cols[7],
                                        db_vendorCountry: cols[8],
                                        db_costPerUnit: cols[9],
                                        db_qtyInStock: cols[10],
                                        db_qtyInUse: cols[101],
                                        db_dateCreated: cols[12],
                                        db_attachment: cols[13],

                                    })
                                });


                            
                                if(searchCategory === 'delete_stock_item')
                                {
                                    setViewItemDetailsData([]);
                    
                                    getItemDetailData(cols[0]);   
                                    document.getElementById('deleteItemGrid').style.display = 'inline-block';
                                }
                            }

                    })
        }
    function getItemDetailData(itemID) {

            //alert('In getEmployeeDetailData');
            //alert(acctID);
            //alert(employeeID);

            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: 74408,
                    user: acctID,
                    xInventoryItemID: itemID,
                    sessionID: sessionID,
                }),
            }
            
            fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(res => {

                let rows = res.toString().split('~~~');

                for (let rownum = 0; rownum < rows.length - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');

                    setViewItemDetailsData((prevViewItemDetailsData) => {
                        return prevViewItemDetailsData.concat({
                            itemID: cols[0],
                            itemName: cols[1],
                            vendorPartNum: cols[2],
                            vendorName: cols[3],
                            costPerUnit: parseFloat(cols[4]).toFixed(2),
                            qtyInStock: cols[5],
                            qtyInUse: cols[6],
                            dateReplenished: cols[7],
                        })
                    });
                } 
            })
        }

    function stockRoomItems(event)
    {

        /*let formData = new FormData();
        formData.append('Tracker', 74303);
        formData.append('user', acctID);
        formData.append('xInventoryRoomID', roomID);
        formData.append('xInventoryItemID', itemID);
        formData.append('xInventoryItemAddedToRoom', quantityAddedToRoom);


        const requestOptions = {
            method:'POST',
            credentials: 'include',
            body: formData,
        }
        */

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            //body: JSON.stringify({formData})
            body: JSON.stringify({
                Tracker: 74303,
                user: acctID,
                xInventoryRoomID: roomID,
                xInventoryItemID: event,
                xInventoryItemAddedToRoom: quantityAddedToRoom,
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);
        })
        .catch(error => {
            console.error(error);
        })

        setStockInventoryRoomModal(false);
    }
    function replenishStock()
    {

        /*
        let formData = new FormData();
        formData.append('Tracker', 72303);
        formData.append('user', acctID);
        formData.append('xInventoryItemID', itemID);
        formData.append('xInventoryReplenishStock', quantityReplenishedStock);


        const requestOptions = {
            method:'POST',
            credentials: 'include',
            body: formData,
        }
        */

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            //body: JSON.stringify({formData})
            body: JSON.stringify({
                Tracker: 72303,
                user: acctID,
                xInventoryItemID: itemID,
                xInventoryReplenishStock: quantityReplenishedStock,
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);
        })
        .catch(error => {
            console.error(error);
        })

        setCreateInventoryRoomModal(false);
    }


function getRoomDetailData(roomID) {

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: 74308,
                user: acctID,
                xInventoryRoomID: roomID,
                sessionID: sessionID,
            }),
        }

        const requestOptions2 = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: 74310,
                user: acctID,
                xInventoryRoomID: roomID,
                sessionID: sessionID,
            }),
        }
        
        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            let rows = res.toString().split('~~~');

                let cols = rows[0].split('|');

                //setRoomID(cols[0]);


                // setViewRoomDetailsData((prevViewRoomDetailsData) => {
                //     return prevViewRoomDetailsData.concat({
                //         roomID: cols[0],
                //         roomType: cols[1],
                //         roomDescription: cols[2],
                //         roomPartNum: cols[3],
                //         roomPhoneNumber: cols[4],
                //         roomAddress: cols[5],
                //         roomCity: cols[6],
                //         roomCountry: cols[7],
                //         roomCostPerUnit: parseFloat(cols[8]).toFixed(2),
                //         roomSalePrice: parseFloat(cols[9]).toFixed(2),
                //         roomDateCreated: cols[10],
                //     })
                // });

                setRoomID(cols[0]);
                setRoomType(cols[1]);
                setRoomDescription(cols[2]);
                setRoomPartNum(cols[3]);
                setRoomPhoneNumber(cols[4]);
                setRoomAddress(cols[5]);
                setRoomCity(cols[6]);
                setRoomCountry(cols[7]);
                setRoomCostPerUnit(parseFloat(cols[8]).toFixed(2));
                setRoomSalePrice(parseFloat(cols[9]).toFixed(2))
                setRoomDateCreated(cols[10]);
                setRoomPic1(cols[11]);
                setRoomPic2(cols[12]);
                setRoomPic3(cols[13]);
                setRoomPic4(cols[14]);
                //setRoomAddedBy(cols[11]);
                setRoomIsActivated(cols[15]);
            
        })

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions2)
        .then(res => res.text())
        .then(res => {

            let rows = res.toString().split('~~~');

            for (let rownum = 0; rownum < rows.length - 1; ++rownum)
            {
                let cols = rows[rownum].split('|');


                setViewRoomItemsDetailsData((prevViewRoomItemsDetailsData) => {
                    return prevViewRoomItemsDetailsData.concat({
                        itemID: cols[0],
                        itemName: cols[1],
                        QtyAvailable: cols[2],
                        dateAdded: cols[3],
                        addedBy: cols[4],
                    })
                });

            }
            
        })

    }

    function updateRoomDetails()
    {

        alert("inside update room");

        let formData = new FormData();
        //formData.append('xRoomPics', totalRoomPics);
        //formData.append('xRoomPics', [roomPic1, roomPic2, roomPic3, roomPic3]);
        formData.append('Tracker', "11_update_room_details");
        formData.append('user', acctID);
        formData.append('merchantSchema', schema);
        formData.append('xInventoryRoomID', roomID);
        formData.append('xInventoryRoomType', roomType);
        formData.append('xInventoryRoomDescription', roomDescription);
        formData.append('xInventoryRoomPartNum', roomPartNum);
        formData.append('xInventoryRoomPhoneNumber', roomPhoneNumber);
        formData.append('xInventoryRoomAddress', roomAddress);
        formData.append('xInventoryRoomCity', roomCity);
        formData.append('xInventoryRoomCountry', roomCountry);
        formData.append('xInventoryRoomCostPerUnit', roomCostPerUnit);
        formData.append('xInventoryRoomSalePrice', roomSalePrice);
        formData.append('xInventoryRoomPublicPrice', roomPublicPrice);
        formData.append('xSupportingDocumentation', selectedFile);
        //formData.append('xEnterAdminPassword', adminPassword);
        formData.append('xPic1', roomPic1);
        formData.append('xPic2', roomPic2);
        formData.append('xPic3', roomPic3);
        formData.append('xPic4', roomPic4);
        formData.append('sessionID', sessionID);

        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        


        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            alert(res);

            props.closeModal();
        })
    }


function updateShowRoomDetails(event) {

    if(event[0])
    {

        setViewRoomDetailsData([]);
        setViewRoomItemsDetailsData([]);
        setShowRoomDetails(event[0]);

        getRoomDetailData(event[1]);

        if(event[2] === "no")
        {
            setActivateRoomButton('inline-block');
            setDeactivateRoomButton('none');

        }
        else if(event[2] === "yes")
        {

            setActivateRoomButton('none');
            setDeactivateRoomButton('inline-block');   
        }
    }
    else{

        setShowRoomDetails([]);
        setViewRoomDetailsData([]);
        setViewItemDetailsData([]);
    }
}

/*function saveRoomPictures(event) { 

    setRoomPic1(event.target.files[0]);
    setRoomPic2(event.target.files[1]);
    setRoomPic3(event.target.files[2]);
    setRoomPic4(event.target.files[3]);


}*/

function activationStatus(event) {

    const requestOptions = {
        method: 'POST',
        //credentials: 'include',
        headers: {
            'Accept': 'text/html, application/json',
            'content-type': 'application/json',
            //'cookie': 'cookie',
        },
        body: JSON.stringify({
            Tracker: 74309,
            user: acctID,
            xInventoryRoomID: roomID,
            xRoomActivationStatus: event,
            sessionID: sessionID,
        }),
    }
    
    fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
    .then(res => res.text())
    .then(res => {

        alert(res);
    })

    setShowRoomPics(false);
    setViewRoomDetailsData([]);
    setViewItemDetailsData([]);
}

let timeout;

function handleInput(event) {


    document.getElementById('searchInventoryRoom_StockRoomItemsList').innerHTML = '';


    //document.getElementById('searchInventoryItem_StockItemList').innerHTML = '';

    //alert('Inside handel input 3');
    //alert(event);

    clearTimeout(timeout); // Clear the previous timeout to reset the delay
    timeout = setTimeout(searchList(event), 2000); // Set a new timeout

}

function handleSelection() {

    setViewItemDetailsData([]);

    const selectedItemName = roomItemNameRef.current.value;
    const selectedItem = searchResults.find(result => result.db_itemName === selectedItemName);
  
    if (selectedItem) {
      // Execute your function here using selectedItem.db_itemId
      getItemDetailData(selectedItem.db_itemId);
    }
}


function roomPicsModalHandler(event) {
    setRoomPic1(event[1]);
    setRoomPic2(event[2]);
    setRoomPic3(event[3]);
    setRoomPic4(event[4]);
    setRoomID(event[5]);
    setRoomSalePrice(event[6]);
    setRoomPicsModal(event[0]);

}

function setShowPasswordModalHandler(event)
{
    setPasswordCategory(event[1]);
    setShowPasswordModal(event[0]);

}

function handleCreateRoomSalePrice(event) {
    const salePrice = parseFloat(event) || 0; // convert to number, default 0
    setRoomSalePrice(salePrice);

    const productPublicPrice = salePrice + (salePrice * 0.03);
    setRoomPublicPrice(productPublicPrice);
}


function hotelInventory_roomsHandler()
{
    setInventory_roomsTab_data(true);
    setInventory_itemsTab_data(false);

    setInventory_roomsTab_view('outline');
    setInventory_itemsTab_view('clear');



}
function hotelInventory_itemsHandler()
{
    setInventory_roomsTab_data(false);
    setInventory_itemsTab_data(true);

    setInventory_roomsTab_view('clear');
    setInventory_itemsTab_view('outline');

}

async function handleSlideChange()
{

    let swiper = await slideRef.current?.getSwiper();

    //let activeIndex = swiper?.activeIndex; // Get the current slide index

    let realIndex = swiper?.realIndex; // Get the actual slide index (ignores duplicate slides)

    //alert(realIndex);

    if (realIndex === 0) { // Example: Execute a function when reaching slide 3
        hotelInventory_roomsHandler();
    }
    else if (realIndex === 1) { // Example: Execute a function when reaching slide 3
        hotelInventory_itemsHandler();
    }
  };

  const slideOpts = {
    initialSlide: 0, // Start at the first slide
    speed: 100, // Animation speed (in ms)
    loop: false, // Enable looping
  };



useEffect(() =>  {

    setLoading(true);

        
        getRoomDetailData(props.data.roomID);   

}, [])

//alert('In Management _ Inventory');
//alert(props.openModal);
//alert(authenticatedMerchent_context.accessRights[0]);
//alert(authenticatedMerchent_context.device);

        return (

            <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal id='showRoomDetails' isOpen={ props.openModal}>
                        <IonHeader>
                            <IonGrid >
                                <IonRow>
                                            <IonCol >Room ID</IonCol>
                                            <IonCol >Date Created</IonCol>
                                </IonRow>
                                <IonRow >
                                    <IonCol >{roomID}</IonCol>
                                    <IonCol >{roomDateCreated}</IonCol>
                                </IonRow>

                                <IonRow>
                                    <IonCol size='6'>
                                        <h4>Details</h4>
                                    </IonCol>
                                    <IonCol size='6'>
                                        <h4>Stock Items</h4>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                        </IonHeader>
                        <IonContent className='grid_content'>
                        <IonSlides>
                            <IonSlide>
                                <IonGrid className='grid_content'>
                                    <IonRow>
                                        {roomIsActivated == "no" && <IonCol size='12'>
                                            <IonButton id='roomIsDeactivated' onClick={() => activationStatus("yes")}> ACTIVATE </IonButton>
                                            </IonCol>}
                                        {roomIsActivated == "yes" && <IonCol size='12'>
                                            <IonButton id='roomIsActivated' onClick={() => activationStatus("no")}> DEACTIVATE </IonButton> 
                                        </IonCol>}
                                    </IonRow>
                                    <IonRow>
                                        <IonCol size='6'>
                                            <label >Type: </label>
                                        </IonCol>
                                        <IonCol size='6'>
                                            <IonInput className='professional-input' type='text' value={roomType} placeholder='Enter Room Type' autocomplete='off' onIonChange={(e) => setRoomType(e.target.value)} required></IonInput>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol size='6'>
                                            <label >Description: </label>
                                        </IonCol>
                                        <IonCol size='6'>
                                            <IonInput className='professional-input' type='text' value={roomDescription} placeholder='Enter Room Description' autocomplete='off' onIonChange={(e) => setRoomDescription(e.target.value)} required></IonInput>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol size='6'>
                                            <label >Part Number: </label>
                                        </IonCol>
                                        <IonCol size='6'>
                                            <IonInput className='professional-input' type='text' value={roomPartNum} placeholder='Enter Room Part Number' autocomplete='off' onIonChange={(e) => setRoomPartNum(e.target.value)} required></IonInput>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol size='6'>
                                            <label >Phone Number: </label>
                                        </IonCol>
                                        <IonCol size='6'>
                                            <IonInput className='professional-input' type='text' value={roomPhoneNumber} placeholder='Enter Room Phone Number' autocomplete='off' onIonChange={(e) => setRoomPhoneNumber(e.target.value)} required></IonInput>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol size='6'>
                                            <label >City: </label>
                                        </IonCol>
                                        <IonCol size='6'>
                                            <IonInput className='professional-input' type='text' value={roomCity} placeholder='Enter Room Description' autocomplete='off' onIonChange={(e) => setRoomCity(e.target.value)} required></IonInput>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol size='6'>
                                            <label >Country: </label>
                                        </IonCol>
                                        <IonCol size='6'>
                                            <IonInput className='professional-input' type='text' value={roomCountry} placeholder='Enter Room Description' autocomplete='off' onIonChange={(e) => setRoomCountry(e.target.value)} required></IonInput>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol size='6'>
                                            <label >Cost Per Unit: </label>
                                        </IonCol>
                                        <IonCol size='6'>
                                            <IonInput className='professional-input' type='text' value={roomCostPerUnit} placeholder='Enter Room Description' autocomplete='off' onIonChange={(e) => setRoomCostPerUnit(e.target.value)} required></IonInput>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol size='12'>
                                            <IonLabel className="form-label" position="stacked" >Merchant Price:</IonLabel>
                                            <IonInput className='professional-input'
                                            value={roomSalePrice}
                                            type='number' 
                                            step='any'
                                            placeholder="Enter Room Sale Price"
                                            onIonChange={(e) => handleCreateRoomSalePrice(e.target.value)}
                                            required
                                            ></IonInput>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol size='6'>
                                            <IonLabel className="form-label" position="stacked" >Room Public Price:</IonLabel>
                                        </IonCol>
                                        <IonCol size='6'>
                                            <IonText className='professional-text'>{roomPublicPrice}</IonText>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol size='6'>
                                            <IonButton onClick={() => updateRoomDetails()}>Save </IonButton>
                                        </IonCol>
                                        <IonCol size='6'>
                                            <IonButton onClick={() => props.closeModal()}>Cancel </IonButton>
                                        </IonCol>
                                    </IonRow>
                            </IonGrid>
                            </IonSlide>
                            <IonSlide>
                                <IonGrid >
                                    <IonRow>
                                        <IonCol size='12'>
                                            <IonButton onClick={() => setStockInventoryRoomModal(true)}> Add Item </IonButton>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow >
                                                <IonCol >Item ID</IonCol>
                                                <IonCol >Item Name</IonCol>
                                                <IonCol >Qty Avaialble</IonCol>
                                                {/*<IonCol >Date Added</IonCol>*/}
                                                {/*<IonCol >Added by</IonCol>*/}
                                                <IonCol >Action</IonCol>
                                    </IonRow>
                                    {viewRoomItemsDetailsData.map((detailData) =>   {
                                        return (
                                            <IonRow >
                                                <IonCol >{detailData.itemID}</IonCol>
                                                <IonCol >{detailData.itemName}</IonCol>
                                                <IonCol >{detailData.QtyAvailable}</IonCol>
                                                {/*<IonCol >{detailData.dateAdded}</IonCol>*/}
                                                {/*<IonCol >{detailData.addedBy}</IonCol>*/}
                                                <IonCol >
                                                    <IonButton> update </IonButton>
                                                </IonCol>
                                            </IonRow>
                                        )
                                    }
                                    )}
                                </IonGrid>
                            </IonSlide>
                        </IonSlides>
                    </IonContent>

                    {stockInventoryRoomModal == true && <Modal_CreateIngredient openModal={ stockInventoryRoomModal } closeModal={() => setStockInventoryRoomModal(false)} startDate={authenticatedMerchent_context.startDate} endDate={authenticatedMerchent_context.endDate} data={{
                        itemType: 'HOTEL', 
                                        }}></Modal_CreateIngredient>}
                </IonModal>) : null}
            </React.Fragment>
        )
    }   